export interface RegisterSystemOperationMenuRequest {
  name: string
  closingDay: string
  patrolDay: string
  scheduledReturnDateSlide: string
  lendAndUserCheck: string
  lendAndReturnConditions: string
  reservationConditions: string
  setVolume: string
  reservationGroup: string
  shelfTypeConversionInfo: string
  lendCountConfirmation: string
  authorDelete: string
  synonymSetting: string
  separateDictionarySetting: string
  newArrivalMagazineMailSetting: string
  code: string
  config: string
  systemCheck: string
  traderAndDonor: string
  loginUser: string
  notice: string
  budgetManagement: string
  returnHistorySearch: string
  referenceImage: string
}

export function RegisterSystemOperationMenuRequestToJSON(
  value: RegisterSystemOperationMenuRequest
): any {
  return {
    name: value.name !== '' ? value.name : undefined,
    closing_day: value.closingDay !== '' ? value.closingDay : undefined,
    patrol_day: value.patrolDay !== '' ? value.patrolDay : undefined,
    scheduled_return_date_slide:
      value.scheduledReturnDateSlide !== ''
        ? value.scheduledReturnDateSlide
        : undefined,
    lend_and_user_check:
      value.lendAndUserCheck !== '' ? value.lendAndUserCheck : undefined,
    lend_and_return_conditions:
      value.lendAndReturnConditions !== ''
        ? value.lendAndReturnConditions
        : undefined,
    reservation_conditions:
      value.reservationConditions !== ''
        ? value.reservationConditions
        : undefined,
    set_volume: value.setVolume !== '' ? value.setVolume : undefined,
    reservation_group:
      value.reservationGroup !== '' ? value.reservationGroup : undefined,
    shelf_type_conversion_info:
      value.shelfTypeConversionInfo !== ''
        ? value.shelfTypeConversionInfo
        : undefined,
    lend_count_confirmation:
      value.lendCountConfirmation !== ''
        ? value.lendCountConfirmation
        : undefined,
    author_delete: value.authorDelete !== '' ? value.authorDelete : undefined,
    synonym_setting:
      value.synonymSetting !== '' ? value.synonymSetting : undefined,
    separate_dictionary_setting:
      value.separateDictionarySetting !== ''
        ? value.separateDictionarySetting
        : undefined,
    new_arrival_magazine_mail_setting:
      value.newArrivalMagazineMailSetting !== ''
        ? value.newArrivalMagazineMailSetting
        : undefined,
    code: value.code !== '' ? value.code : undefined,
    config: value.config !== '' ? value.config : undefined,
    system_check: value.systemCheck !== '' ? value.systemCheck : undefined,
    trader_and_donor:
      value.traderAndDonor !== '' ? value.traderAndDonor : undefined,
    login_user: value.loginUser !== '' ? value.loginUser : undefined,
    notice: value.notice !== '' ? value.notice : undefined,
    budget_management:
      value.budgetManagement !== '' ? value.budgetManagement : undefined,
    return_history_search:
      value.returnHistorySearch !== '' ? value.returnHistorySearch : undefined,
    reference_image:
      value.referenceImage !== '' ? value.referenceImage : undefined
  }
}
